import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { UploadReqPageComponent } from './upload-req-page.component';
import { UploadReqStepUploadModule } from './upload-req-step-upload/upload-req-step-upload.module';
import { UploadReqStepRecruitersModule } from './upload-req-step-recruiters/upload-req-step-recruiters.module';
import { UploadReqStepWorkflowModule } from './upload-req-step-workflow/upload-req-step-workflow.module';
import { UploadReqStepJobBoardsModule } from './upload-req-step-job-boards/upload-req-step-job-boards.module';
import { UploadReqStepActivateModule } from './upload-req-step-activate/upload-req-step-activate.module';
import { UploadReqStepResultsModule } from './upload-req-step-results/upload-req-step-results.module';
import { RequisitionCardIconsModule } from 'src/app/shared/requisition-card-icons/requisition-card-icons.module';

const states: Ng2StateDeclaration[] = [
  {
    name: 'missioncontrol.uploadreq',
    url: '/uploadreq',
    component: UploadReqPageComponent,
    data: {
      requireLogin: true
    },
    params: {
      jobId: null,
      jobState: null,
      isNewReq: null,
      asyncActionType: null,
      workflowSteps: null,
      fourDotFiveIntelligentThresholdScore: null,
      vendorsDetails: null
    }
  }
];

@NgModule({
  declarations: [UploadReqPageComponent],
  imports: [
    CommonModule,
    PopoverModule.forRoot(),
    TooltipModule.forRoot(),
    UploadReqStepUploadModule,
    UploadReqStepRecruitersModule,
    UploadReqStepWorkflowModule,
    UploadReqStepJobBoardsModule,
    UploadReqStepActivateModule,
    UploadReqStepResultsModule,
    RequisitionCardIconsModule,
    UIRouterModule.forChild({ states })
  ],
  exports: [UploadReqPageComponent],
  entryComponents: [UploadReqPageComponent]
})
export class UploadReqPageModule { }
